// src/pages/Ads/components/TosPolicyFull.jsx
import React from "react";

export default function TermsPolicyFull() {
  return (
    <article className="prose prose-sm max-w-none leading-relaxed break-words">
      <h1 className="text-lg font-bold">WizMarket 이용약관 (제정 v1.0)</h1>

      <h2 className="font-semibold">제1장 총칙</h2>

      <h3 className="font-semibold py-2">제1조(목적)</h3>
      <p>
        본 약관은 WizMarket(이하 “서비스”)의 제공자인 회사가 서비스를 이용하는 회원 간의 권리·의무 및 책임사항, 서비스 이용에 관한 제반 사항을 규정함을 목적으로 합니다. 본 서비스는 생성형 AI 기능을 활용하여 광고 이미지를 제작하고, 편집·템플릿 적용, SNS(예: 인스타그램, 카카오톡 등) 채널에 업로드·공유를 지원하는 마케팅 지원 서비스입니다.
      </p>

      <h3 className="font-semibold py-2">제2조(용어의 정의)</h3>
      <p>① 이 약관에서 사용하는 용어의 정의는 다음과 같습니다. </p>
      <p>1. 회사: 본 서비스를 제공·운영하는 자. </p>
      <p>2. 회원: 본 약관에 동의하고 회사와 서비스 이용계약을 체결하거나 회사가 이용을 승낙한 자. </p>
      <p>3. AI 생성물: 서비스의 생성형 AI 기능을 통해 자동으로 생성된 광고 이미지 등 산출물. </p>
      <p>4. 결제: 회사가 정한 결제시스템(PG 등)에 회원의 결제수단 정보를 입력하여 서비스 이용에 필요한 대금을 지급하는 행위. </p>
      <p>5. 플랜(요금제): 스탠다드, 프리미엄, 컨시어지, 베이직 단품 등 회사가 정한 요금제 유형으로서, 각 플랜의 월 부여 토큰 수·제공 범위·요금은 서비스 내 요금제 안내 및 운영정책(또는 별표)에 따릅니다. </p>
      <p>6. 토큰: 서비스 내 생성형 AI 기능으로 광고 이미지를 1건 생성할 때마다 1개씩 차감되는 사용 단위. 토큰은 계정 단위로 부여·차감되며, 정기 구독으로 지급된 토큰은 1개월(30일)동안 유효합니다(미사용분 이월 불가). 베이직 단품 플랜의 토큰 유효기간 등 기타 조건은 운영정책에 따릅니다. </p>
      <p>7. 채널/포스팅하기: 회원이 생성·편집한 콘텐츠를 외부 SNS·메신저 등 제3자 채널에 업로드·공유하도록 지원하는 기능(서비스 내 UI 명칭 ‘포스팅하기’ 포함). </p>
      <p>8. 이용정지: 본 약관 또는 운영정책에서 정한 요건에 따라 일정 기간 서비스 이용을 제한 또는 정지하는 조치. </p>
      <p>9. 이용해지(구독해지): 회원이 구독 등 유료 서비스 이용을 종료하는 행위. </p>
      <p>10. 탈퇴(계약해지): 회원이 회사와 체결한 서비스 이용계약을 종료하는 행위.</p>
      <p>② 본 약관에서 정의되지 않은 용어는 관련 법령, 개별 서비스 안내, 운영정책 및 일반 관례에 따릅니다.</p>

      <h3 className="font-semibold py-2">제3조(약관의 게시와 개정)</h3>
      <p>① 회사는 이 약관의 내용을 회원이 쉽게 알 수 있도록 가입 시 동의 절차 또는 서비스 초기화면 및 사용 메뉴 등에 게시합니다. </p>
      <p>② 회사는 “약관의 규제에 관한 법률”, “정보통신망 이용촉진 및 정보보호 등에 관한 법률”, “전자상거래 등에서의 소비자보호에 관한 법률” 등 관련 법령에 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다. </p>
      <p>③ 회사가 약관을 개정할 경우 적용일자 및 개정사유를 명시하여 현행 약관과 함께 제1항의 방식에 따라 그 개정약관의 적용일자 7일 전부터 적용일까지 공지합니다. 다만, 회원의 권리 또는 의무에 관한 중요한 규정의 변경은 최소한 30일 전에 공지하고, 일정 기간 서비스 내 공지사항, 전자우편, 로그인 시 동의창 등의 전자적 수단으로 명확히 통지합니다. </p>
      <p>④ 회사가 전항에 따라 “개정된 약관의 적용일까지 거부 의사를 표시하지 않으면 동의한 것으로 본다”는 뜻을 공지하거나 통지한 경우, 공고 또는 통지한 날로부터 7일 이내에 명시적으로 거부의사를 표시하지 아니한 경우 회원은 개정된 약관에 동의한 것으로 봅니다. </p>
      <p>⑤ 회원이 개정된 약관의 적용에 동의하지 아니한 경우 회사는 개정된 약관의 내용을 회원에게 적용할 수 없으며, 이 경우 회원은 이용계약을 해지할 수 있습니다. 다만, 개정 약관을 적용할 수 없는 특별한 사정이 있는 경우 회사는 회원의 동의하에 그 이용계약을 해지할 수 있습니다. </p>
      <p>⑥ 회원은 변경된 약관의 내용에 대하여 숙지할 주의의무를 부담하며, 부주의로 숙지하지 못한 변경된 약관으로 인한 회원의 피해는 회사가 책임지지 않습니다. </p>
      <p>⑦ 이 약관의 적용기간은 회원의 가입일부터 탈퇴일까지로 합니다. 다만, 채권 또는 채무관계가 있을 경우에는 그 완료일까지로 합니다.</p>

      <h2>제2장 이용계약의 체결 및 관리</h2>

      <h3 className="font-semibold py-2">제4조(이용계약 체결)</h3>
      <p>① 이용계약은 이용자가 되고자 하는 자(이하 “가입신청자”)가 본 약관에 동의한 후 회원가입 신청을 하고, 회사가 이를 승낙함으로써 체결됩니다. </p>
      <p>② 회사는 가입신청자의 신청에 대하여 원칙적으로 승낙합니다. 다만, 다음 각 호의 어느 하나에 해당하는 경우 승낙을 거절할 수 있습니다. </p>
      <p>1. 가입신청자가 본 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우(재가입을 회사가 승낙한 경우 예외) </p>
      <p>2. 실명이 아니거나 타인의 명의를 이용함이 확인된 경우 </p>
      <p>3. 허위 정보를 기재하거나, 회사가 제시하는 필수 항목을 기재하지 않은 경우 </p>
      <p>4. 만 14세 미만인 경우 </p>
      <p>5. 회사가 제공하는 서비스 중 어느 하나에 대하여 제18조에 따라 계약 해지를 당한 후 1년이 경과하지 않은 경우 </p>
      <p>6. 가입신청자의 이용이 서비스의 정상적 제공을 저해하거나 다른 회원의 이용에 지장을 줄 것으로 예상되는 경우 </p>
      <p>7. 가입신청자의 이용이 관련 법령 등에 따라 금지되거나, 사회질서·미풍양속에 반할 우려가 있다고 인정되는 경우 </p>
      <p>③ 회사는 승낙 전에 회원의 종류에 따라 전문기관을 통한 실명확인 또는 본인인증을 요청할 수 있습니다. </p>
      <p>④ 회사는 서비스 관련 설비의 여유가 없거나 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다. </p>
      <p>⑤ 이용계약의 성립 시기는 회사가 가입완료를 신청절차 상에 표시한 시점으로 합니다. </p>
      <p>⑥ 회사는 회원에 대하여 회사정책에 따라 등급별로 구분하여 이용시간, 이용횟수, 서비스 메뉴 등을 세분하여 그 이용에 차등을 둘 수 있습니다. </p>
      <p>⑦ 서비스의 대량 이용 등 특별한 이용에 관한 계약은 별도의 계약으로 정할 수 있습니다.</p>

      <h3 className="font-semibold py-2">제5조(개인정보 수집)</h3>
      <p>① 회사는 적법하고 공정한 수단에 의하여 이용계약의 성립 및 이행에 필요한 최소한의 개인정보를 수집하며, 회원은 이에 동의하여야 합니다. </p>
      <p>② 회사는 개인정보 수집 시 관련 법규에 따라 개인정보처리방침에 그 수집 범위 및 목적을 사전 고지합니다. </p>
      <p>③ 회사는 회원이 서비스 화면에서 자신의 개인정보 수집·이용 또는 제공에 대한 동의를 철회할 수 있도록 필요한 조치를 취합니다.</p>

      <h3 className="font-semibold py-2">제6조(개인정보보호 의무)</h3>
      <p>
        회사는 “개인정보 보호법”, “정보통신망법” 등 관계 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력하며, 개인정보의 보호 및 사용에 대해서는 관련 법령 및 회사의 개인정보처리방침이 적용됩니다. 다만, 회사의 공식 사이트 이외의 링크된 사이트에서는 회사의 개인정보처리방침이 적용되지 않습니다.
      </p>

      <h3 className="font-semibold py-2">제7조(개인정보의 변경)</h3>
      <p>① 회원은 개인정보 설정 화면을 통하여 본인의 정보를 열람 및 수정할 수 있습니다. 다만, 법인 회원은 홈페이지 및 애플리케이션에 기재된 회사의 전화 또는 전자메일을 통해 정보 수정을 요청할 수 있습니다. </p>
      <p>② 회원은 서비스 이용신청 시 기재한 사항이나 서비스 이용 과정에서 회사에 제공한 정보가 변경되었을 경우 전항의 방법으로 정보를 변경하여야 하며, 변경하지 아니함으로써 발생한 불이익에 대하여 회사는 책임지지 않습니다.</p>

      <h3 className="font-semibold py-2">제8조(회원에 대한 통지)</h3>
      <p>① 회사가 회원에 대한 통지를 하는 경우, 서비스 내 공지사항 게시 또는 전자우편·앱 푸시·서비스 내 알림 등으로 할 수 있습니다. 회원이 연락처 정보를 허위로 제출하거나 변경 사실을 회사에 알리지 않은 경우, 회사가 등록 정보로 발송한 때에 도달한 것으로 봅니다. </p>
      <p>② 회사는 전체 또는 불특정 다수 회원에 대한 통지의 경우 7일 이상 서비스 내 공지사항 게시로 제1항의 통지에 갈음할 수 있습니다. </p>
      <p>③ 회원은 회사에 실제 연락이 가능한 연락처 정보를 제공하고 이를 최신 상태로 유지하여야 합니다.</p>

      <h2 className="font-semibold">제3장 권리·의무</h2>

      <h3 className="font-semibold py-2">제9조(회사의 의무)</h3>
      <p>① 회사는 관련 법령과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 생성형 AI 기반 광고 이미지 생성 및 채널 업로드 연동을 포함한 서비스를 계속적·안정적으로 제공하기 위해 최선을 다합니다. </p>
      <p>② 회사는 회원이 안전하게 서비스를 이용할 수 있도록 개인정보(결제정보 포함) 보호를 위한 기술적·관리적 보호조치를 갖추고, 개인정보처리방침을 공시·준수합니다. </p>
      <p>③ 회사는 서비스 제공과 관련하여 알게 된 회원의 개인정보를 회원의 동의 없이 제3자에게 제공·누설하지 않습니다. 다만, 법령에 따른 적법한 절차에 의한 수사·감독기관의 요구가 있는 경우에는 예외로 합니다. </p>
      <p>④ 회사는 서비스 제공 목적에 맞는 이용 여부 및 정상 운영 상태를 확인하기 위해 필요한 범위에서 자동·수동 모니터링을 실시할 수 있으며, 시스템 장애 또는 고장 발생 시 신속히 수리·복구합니다. 다만 천재지변, 비상사태, 통신망 장애, 외부 채널의 정책·API 변경 등 부득이한 사유가 있는 경우 서비스가 일시 중단될 수 있습니다. </p>
      <p>⑤ 회사는 서비스의 안정화·고도화·기능 개선을 위해 사전에 공지하고 애플리케이션/웹 및 관련 소프트웨어의 업데이트, 시스템 점검을 실시할 수 있습니다. 긴급한 사안이 있는 경우 사전 고지 없이 조치하고 사후 통지할 수 있습니다. </p>
      <p>⑥ 회사는 회원이 토큰 잔액·부여·차감 이력, AI 생성 이력, 채널 업로드/연동 상태 등을 서비스 화면에서 확인할 수 있도록 제공하여 회원이 수시로 자체 관리할 수 있도록 지원합니다. </p>
      <p>⑦ 회사는 불법·유해 콘텐츠 유통 방지 및 외부 채널 정책 준수를 위해, 권리침해·음란·명예훼손·악성코드 유포 등으로 판단되는 콘텐츠 또는 비정상 트래픽·자동화 남용 등에 대해 필터링·차단·속도 제한 등 합리적 범위의 조치를 취할 수 있습니다. </p>
      <p>⑧ 회사는 권리침해 신고, 개인정보·보안, 결제·환불, 채널 연동 관련 문의 등 민원 처리를 위한 고충처리 창구(서비스 내 공지된 고객센터/이메일 등)를 운영하고, 정당한 민원은 지체 없이 처리합니다. </p>
      <p>⑨ 회사는 분쟁 대응, 안정적 운영, 법령 준수를 위해 필요한 범위에서 접속 기록, 생성·업로드 로그 등 최소한의 서비스 이용기록을 개인정보처리방침 및 관계 법령에서 정한 기간 동안 보관·관리하며, 보관 기간 경과 시 지체 없이 파기 또는 익명화합니다. 법령상 허용·요구되는 경우를 제외하고 삭제된 로그는 제공하지 않습니다. </p>
      <p>⑩ 회사는 회원으로부터 제기된 의견이나 불만이 정당하다고 인정되는 경우 즉시 처리하며, 처리 과정 및 결과를 회원의 등록 연락처(이메일 등)로 통지할 수 있습니다. </p>
      <p>⑪ 회사는 외부 채널(예: 인스타그램, 카카오톡 등) 연동을 위한 권한 부여·유지를 지원하며, 채널 사업자의 정책·기술 변경, 점검·장애, 위법·정책위반 판단 등에 따라 연동 기능이 제한·변경·중단될 수 있음을 고지합니다. 플랫폼 또는 관계기관의 요청·위험 징후로 긴급 차단이 필요한 경우 사전 고지 없이 차단하고 사후 통지할 수 있습니다. </p>
      <p>⑫ 전항과 관련하여 회사는 차단·제한 조치의 사실 및 사유, 시각, 관련 식별정보 등 필요한 자료를 관계 법령이 정하는 범위에서 최대 1년간 보관할 수 있으며, 적법한 절차에 따라 관계기관에 제출할 수 있습니다. </p>
      <p>⑬ 회사는 회원이 앱/웹 내에서 제공되는 상권 분석 서비스를 이용할 수 있도록 최신 데이터 기반의 지역 정보를 제공하기 위해 노력하며, 그 정확성·적시성 보장을 위한 합리적 절차를 유지합니다. 다만 데이터 특성상 오차가 발생할 수 있으며, 회사의 고의·중과실이 없는 한 법이 허용하는 범위 내에서 책임을 부담합니다. </p>
      <p>⑭ 회사는 상권 분석 서비스의 정확성 유지를 위해 외부 데이터 소스와 협력하고, 데이터 갱신 주기 및 주요 변경 사항을 서비스 내 공지 등 합리적 방법으로 안내합니다.</p>

      <h3 className="font-semibold py-2">제10조(회원의 의무)</h3>
      <p>① 회원은 다음 각 호의 행위를 하여서는 아니 됩니다. </p>
      <p>1. 가입·변경 시 허위 정보 기재, 타인의 계정·비밀번호·연락처 도용 또는 공유·양도 </p>
      <p>2. 회사가 제공하는 시스템·API·에디터 등 서비스 정보를 사전 승낙 없이 복제·유통·상업적 이용, 스크래핑, 역설계(리버스엔지니어링), 무단 자동화(봇/스크립트) 사용 </p>
      <p>3. 지적재산권·초상권·상표권·개인정보 등 제3자 권리를 침해하는 콘텐츠(원본·AI 생성물 포함)의 생성·업로드·유통 </p>
      <p>4. 명예훼손·모욕·차별·혐오·괴롭힘 등 사회 통념상 현저히 부적절한 행위 </p>
      <p>5. 음란물, 청소년유해매체물을 법령상 요건 없이 영리 제공하거나 접근을 유도하는 행위 </p>
      <p>6. 악성코드/바이러스 등록·유포, 과도한 자동화로 비정상 트래픽을 유발하여 서비스 안정성을 저해하는 행위 </p>
      <p>7. 스팸성 업로드·DM·댓글 등 외부 채널의 정책을 위반하거나, 채널의 중요 표시(발신 주체, 광고 표시 등)를 허위로 기재·위장하는 행위 </p>
      <p>8. 토큰의 부정 사용(양도·대여·판매·대리 생성 등), 결제 회피, 차지백/환불 남용 </p>
      <p>9. 서비스 또는 타인의 시스템·계정에 대한 무단 접근·침입, 권한 초과 사용, 취약점 악용 </p>
      <p>10. 회사의 요청 및 정당한 소명·증빙 요구에 불응하거나 허위 자료 제출 </p>
      <p>11. 그 밖에 법령·약관·운영정책 또는 외부 채널 약관에 위반되는 행위 </p>
      <p>② 회원은 다음 각 호에 해당하는 정보(콘텐츠)를 생성·게시·유통하여서는 아니 됩니다. </p>
      <p>1. 청소년보호법상 청소년유해매체물을 영리 목적으로 제공하면서 법정 요건(연령확인·고지 등)을 이행하지 않은 정보 </p>
      <p>2. 음란한 부호·문언·음향·화상 또는 영상의 배포·판매·전시 정보 </p>
      <p>3. 사실 또는 허위의 사실로 타인의 명예를 훼손하는 정보 </p>
      <p>4. 법령에 따라 분류된 비밀 등 국가기밀 누설 정보 및 국가보안법 위반 정보 </p>
      <p>5. 범죄를 목적으로 하거나 교사·방조하는 정보, 불법 행위를 구체적으로 실행·유도하는 정보 </p>
      <p>6. 지적재산권(저작권·상표권 등) 또는 제3자의 초상권·개인정보·기타 권리를 침해, 개인정보 불법 수집·유출, 악성코드 유포 등 기타 불법·부당 정보 </p>
      <p>7. 딥페이크 등 AI 생성물을 이용하여 권리를 침해하거나 법령·채널 정책을 위반하는 정보 </p>
      <p>③ 회사는 회원이 제1항 또는 제2항을 위반한 경우, 필요 범위 내에서 콘텐츠 삭제·비공개, 업로드/연동 제한, 토큰 사용 제한, 기능 제한, 계정 정지·해지 등의 조치를 할 수 있습니다. 긴급한 경우 사전 고지 없이 조치하고 사후 통지할 수 있습니다. </p>
      <p>④ 회원은 콘텐츠 생성·편집·업로드 및 광고 집행과 관련하여 정보통신망법, 표시·광고의 공정화에 관한 법률, 저작권법, 개인정보보호법, 청소년보호법 등 관계 법령과 외부 채널(인스타그램·카카오톡 등) 약관·정책을 준수하여야 하며, 채널별로 요구되는 표시·고지, 사전 동의, 연령 제한 등의 의무를 이행하여야 합니다. </p>
      <p>⑤ 회사는 콘텐츠 생성·편집 및 채널 업로드 연동 도구를 제공할 뿐, 게시·전송의 주체는 회원입니다. 스팸·피싱·저작권 위반·불법 광고성 게시/전송 등으로 발생하는 민·형사·행정상의 책임은 회원에게 귀속됩니다. </p>
      <p>⑥ 회원은 계정 보안 유지(비밀번호 관리, 이중인증 등), 결제수단의 적법한 사용, 연락처·사업자정보 등의 최신성 유지 의무를 부담합니다. 권리침해 신고가 접수되는 경우 회사의 사실 확인·조치에 성실히 협조하여야 합니다.</p>

      <h3 className="font-semibold py-2">제11조(회원 콘텐츠의 권리 및 사용허락)</h3>
      <p>회원은 서비스에 업로드하거나 서비스 이용 과정에서 생성·편집·저장되는 콘텐츠 및 데이터(이하 “회원 콘텐츠”)에 대한 권리를 보유합니다.</p>
      <p>
        회사는 서비스 제공·운영·보안·저장·백업·표시·전송·변환(리사이즈·포맷 변경 등)을 위하여 필요한 범위에서 회원 콘텐츠에 대한 비독점적·무상·전세계적 이용허락을 부여받습니다. 회원이 회원 콘텐츠를 삭제하거나 탈퇴하는 경우, 법령상 보존 의무 또는 분쟁 해결을 위한 범위를 제외하고 합리적인 기간 내 해당 이용허락은 종료됩니다.
      </p>
      <p>
        AI 생성물의 권리 귀속은 관련 법령 및 적용 가능한 라이선스 정책에 따르며, 회사는 AI 생성물에 대한 독자적 권리를 주장하지 않습니다. 다만, 템플릿·폰트·스톡 등 제3자 자산이 포함된 경우 해당 라이선스에 따른 표시·제한을 회원이 준수하여야 합니다.
      </p>
      <p>회원은 제3자의 권리(저작권·상표권·초상권·개인정보 등)를 포함하는 자료 사용 시 적법한 권리·사용허락을 확보하여야 하며, 이에 관한 분쟁 책임은 회원에게 귀속됩니다.</p>

      <h3 className="font-semibold py-2">제11조의2(데이터의 학습·품질 고도화 이용)</h3>
      <p>회사는 서비스 품질 개선(오류 탐지, 보안, 악성 이용 방지, 추천 품질 향상)을 위하여 회원의 서비스 이용과정에서 생성되는 로그·메타데이터를 익명·통계 처리하여 활용할 수 있습니다.</p>
      <p>
        회사는 회원의 원본 콘텐츠를 기계학습(재학습) 데이터로 사용하지 않습니다. 다만, 회원이 설정 화면 등에서 명시적으로 동의(Opt-in)한 경우에 한하여 사용할 수 있으며, 회원은 언제든 동의를 철회할 수 있습니다.
      </p>
      <p>
        회사는 학습 목적의 처리 범위·보존기간·철회 방법을 서비스 내 고지하며, 동의 철회 시 지체 없이 학습용 수집을 중단하고 가능한 범위에서 학습 데이터셋에서의 제거·비식별화 조치를 취합니다.
      </p>

      <h2 className="font-semibold">제4장 회원의 권리 관련 조치</h2>

      <h3 className="font-semibold py-2">제12조(동의의 철회)</h3>
      <p>회사는 회원이 서비스 화면에서 자신의 개인정보 수집·이용 또는 제3자 제공에 대한 동의를 철회할 수 있도록 필요한 조치를 취합니다.</p>

      <h3 className="font-semibold py-2">제13조(불만 처리)</h3>
      <p>① 회사는 개인정보와 관련하여 회원의 의견을 수렴하고, 불만을 처리하기 위한 절차를 마련합니다. </p>
      <p>② 회사는 전화, 전자우편, 고객센터 또는 서비스 화면의 상담창구를 통하여 회원의 불만사항을 접수·처리합니다.</p>

      <h3 className="font-semibold py-2">제13조의2(고객센터 및 권리침해 신고·재게시 청구)</h3>
      <p>고객센터: 서비스 이용 문의·결제/환불·채널 연동·보안 관련 민원은 아래 채널로 접수합니다.</p>
      <p>이메일: [jyesdesign@gmail.com]</p>
      <p>카카오톡/채팅: [https://pf.kakao.com/_hAfxmn]</p>
      <p>운영시간: 평일 10:00~17:00 (점심 12:00~13:00), 주말/공휴일 휴무</p>
      <p>권리침해 신고: 저작권·상표권·초상권·개인정보 등 권리침해가 의심되는 콘텐츠에 대하여 아래 정보를 포함하여 신고할 수 있습니다. 회사는 신속히 사실 확인 후 필요한 범위에서 임시조치(비공개·삭제·연동 제한 등)를 할 수 있습니다.</p>
      <p>신고자 성명/연락처(이메일 포함), 권리자와의 관계</p>
      <p>침해 주장 권리 및 입증자료(등록증, 라이선스, 위임장 등)</p>
      <p>문제 콘텐츠의 위치(URL, 게시 시각, 계정명) 및 침해 내용</p>
      <p>요청 조치(삭제/비공개/연동 제한 등)와 허위 신고가 아님에 대한 확인 및 서명</p>
      <p>※ 대리 신고의 경우 위임장 첨부가 필요합니다.</p>
      <p>처리 절차 및 기한: 회사는 접수 후 72시간 이내 1차 회신, 7일 이내 처리를 원칙으로 하며, 부득이한 경우 10일 범위 내에서 1회 연장하고 사유를 통지합니다.</p>
      <p>임시조치 및 재게시 청구: 필요한 경우 회사는 관련 법령 및 운영정책에 따라 최대 30일간 임시조치를 할 수 있으며, 이해관계인은 재게시 청구 또는 소명 자료를 제출할 수 있습니다. 회사는 제출 자료를 검토하여 합리적인 범위에서 조치 결과를 통지합니다.</p>
      <p>긴급 대응: 아동·청소년 불법촬영물, 명백한 개인정보 유출, 악성코드 유포 등 긴급 사안은 즉시 차단 후 사후 통지합니다.</p>
      <p>자료 보관: 회사는 신고·처리 관련 자료를 법령이 허용하는 범위 내에서 최대 1년간 보관할 수 있으며, 적법한 절차에 따라 관계기관에 제출할 수 있습니다.</p>

      <h3 className="font-semibold py-2">제13조의3(마케팅 정보 수신동의(선택))</h3>
      <p>
        ① 회사는 회원의 사전 동의가 있는 경우에 한하여이메일, SMS/MMS, 카카오(알림톡·친구톡 등), 앱 푸시 등으로 혜택·이벤트·프로모션, 신기능·이용 가이드 등 광고성 정보를 전송할 수 있습니다. 마케팅 정보 수신동의는 선택 사항으로서, 서비스 기본 이용의 필수 조건이 아닙니다.
      </p>
      <p>
        ② 야간(21:00~08:00)시간대 전송은 법령상 별도의 사전 동의가 필요한 매체에 한하여 전송합니다(법령상 야간 규제가 적용되지 않는 매체는 제외). 회사는 관련 법령에 따른 <strong>표시 의무(“(광고)” 표기, 발신자·연락처, 수신거부 방법 등)</strong>를 준수합니다.
      </p>
      <p>
        ③ 회원은 설정 ▷ 알림/마케팅에서 채널별 개별 동의/철회를 할 수 있으며, 각 메시지 하단의 수신거부(UNSUBSCRIBE) 수단을 통해서도 언제든지 철회할 수 있습니다. 회사는 철회 요청을 지체 없이 반영합니다(기술적 처리에 필요한 최소 시간이 소요될 수 있음).
      </p>
      <p>④ 약관 변경, 보안·인증, 결제·요금, 장애·점검 등 법령상 고지 또는 서비스 운영에 필수적인 안내는 마케팅 동의와 무관하게 발송될 수 있습니다.</p>
      <p>⑤ 회사는 관련 법령 및 가이드라인에 따라 수신동의 상태를 주기적으로 재확인할 수 있습니다.</p>
      <p>⑥ 마케팅 목적을 위한 개인정보의 처리 항목, 보유 기간, 수신동의/철회 방법등 세부 사항은 개인정보처리방침을 따릅니다.</p>

      <h2 className="font-semibold">제5장 서비스 이용</h2>

      <h3 className="font-semibold py-2">제14조(서비스 제공 및 제한)</h3>
      <p>① 회사는 회원에게 다음 각 호의 서비스를 제공합니다. </p>
      <p>1. 생성형 AI 광고 이미지 생성: 프롬프트 기반 또는 추천 옵션을 통해 광고 이미지를 생성하며, 이용 시 토큰이 차감됩니다. </p>
      <p>2. 템플릿·에디터 제공: 생성물 편집, 텍스트/레이아웃 적용, 효과 삽입 및 결과물 저장·관리 기능. </p>
      <p>3. 포스팅하기(채널 연동): 인스타그램, 카카오톡 등 외부 SNS·메신저 채널에 업로드·공유를 지원(웹·애플리케이션 기반 제공, 채널 권한 허용 필요). </p>
      <p>4. 플랜·결제·토큰 관리: 구독/단품 플랜 선택, 결제, 토큰 부여·차감 및 사용 이력 조회. </p>
      <p>5. 공지·고객지원 및 기타 부가 기능: 서비스 운영에 필요한 공지 제공과 문의 응대 등.</p>
      <p>6. AI 매장 운영 리포트 : 마케팅 효과분석 및 매장 상권, 입지 정보, AI 운영전략등을 포함한 리포트 </p>

      <p>② 서비스 제공의 제한 및 유의사항은 다음과 같습니다. </p>
      <p>1. 외부 채널 의존성: 채널 사업자의 정책·API 변경, 기술적 사정에 따라 연동 기능이 제한·변경·중단될 수 있습니다. </p>
      <p>2. 운영/장애 사유: 설비 점검·교체, 서비스 고도화, 고장, 통신 장애 등 불가피한 사유로 일시 중단될 수 있습니다. </p>
      <p>3. 권리·정책 준수: 회원은 업로드/공유 콘텐츠 및 AI 생성물이 법령, 제3자 권리, 채널 정책을 침해하지 않도록 확인할 책임이 있으며, 위반 시 게시 중단·이용정지 등 조치가 이루어질 수 있습니다. </p>
      <p>4. 부정 사용 방지: 스팸·자동화 남용, 비정상 트래픽, 토큰 대량 소진 등 위험 징후가 감지될 경우 속도 제한, 기능 제한, 이용정지가 적용될 수 있습니다. </p>
      <p>5. 요금/미납: 요금 미납 또는 결제 실패 시 유료 기능 이용이 제한될 수 있습니다. </p>
      <p>6. 베타/시험 기능: 품질·호환성·지원 범위가 제한될 수 있으며 예고 없이 변경될 수 있습니다. </p>
      <p>7. 보관 한도: 생성물·콘텐츠의 저장 공간/보관 기간은 서비스 내 고지 및 운영정책에 따릅니다. </p>

      <p>③ 회사는 서비스를 일정 범위로 분할하여 각 범위별로 이용 가능한 시간을 별도로 지정할 수 있습니다. 이 경우 그 내용을 사전에 공지합니다. </p>
      <p>④ 서비스는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다. 다만, 회사는 정기 점검 또는 긴급한 사정 등 운영상 필요가 있는 경우 서비스 제공을 일시적으로 중단할 수 있으며, 제8조에 따른 방법으로 통지합니다. 긴급한 사유로 사전 통지가 곤란한 경우 사후 통지할 수 있습니다. </p>
      <p>⑤ 제1항의 각 서비스 및 제휴 서비스의 내용은 변경될 수 있으며, 이 경우 회사는 서비스 내 공지 또는 전자우편 등으로 통지할 수 있습니다. </p>
      <p>⑥ 회사는 다음 각 호의 어느 하나에 해당하는 경우 1개월의 기간을 정하여 회원의 서비스 이용을 정지할 수 있습니다. 다만, 제4호의 사유가 발생한 경우에는 그 사유가 해소될 때까지 이용을 정지할 수 있습니다. </p>
      <p>1. 관련 법령 또는 본 약관·운영정책을 중대하게 위반한 경우 </p>
      <p>2. 저작권·상표권·초상권 등 제3자의 권리를 침해하는 콘텐츠를 생성·게시·유통한 경우 </p>
      <p>3. 스팸성 포스팅, 과도한 자동화 이용(봇/스크립트), 토큰의 부정 사용(양도·대여·판매 등)으로 서비스 질서를 현저히 저해한 경우 </p>
      <p>4. 요금 미납 또는 결제 실패, 차지백·환불 남용 등으로 정상적인 과금 처리가 불가한 경우(해소 시까지) </p>
      <p>5. 외부 채널 정책 위반 또는 권한 미부여·철회로 연동 기능에 중대한 장애를 초래한 경우 </p>
      <p>6. 서비스 또는 타인의 시스템·계정에 대한 무단 접근, 해킹, 역공학, 취약점 악용 행위를 한 경우 </p>
      <p>7. 비정상 트래픽 유발, 장애 유도 등으로 서비스 안정성을 심각하게 저해한 경우 </p>
      <p>8. 타인 사칭, 허위 정보 제공, 본인확인·소명 요구에 정당한 사유 없이 불응한 경우 </p>
      <p>9. 관계 기관의 적법한 요청(수사 협조 등)을 정당한 사유 없이 거부한 경우 </p>
      <p>10. 그 밖에 회사가 합리적으로 판단하여 서비스의 안전한 운영에 중대한 위험이 있다고 인정되는 경우 </p>

      <p>⑦ 회사는 회원의 서비스 이용 내용이 다음 각 호의 어느 하나에 해당하는 경우, 필요한 범위 내에서 서비스 이용을 제한하거나 콘텐츠 삭제·비공개, 업로드/연동 제한, 토큰 사용 제한, 기능 제한, 계정 일시정지 등의 조치를 할 수 있습니다. 중대한 경우 사전 고지 없이 조치하고, 사후 통지할 수 있습니다. </p>
      <p>1. 본 약관, 운영정책 또는 관계 법령을 위반한 경우 </p>
      <p>2. 고의 또는 과실로 서비스 운영을 방해하거나 안정적 운영을 현저히 저해한 경우 </p>
      <p>3. 대량 정보 전송, 비정상 트래픽 유발, 악성코드·바이러스 유포 등으로 설비 오동작 또는 데이터 손상을 야기한 경우 </p>
      <p>4. 지적재산권(저작권·상표권 등), 초상권, 개인정보 등 제3자의 권리를 침해하는 콘텐츠를 생성·게시·유통한 경우 </p>
      <p>5. 방송통신심의위원회 시정요구 또는 선거관리위원회 유권해석 등 관계 기관의 적법한 요구가 있는 경우 </p>
      <p>6. 타인의 계정·권한을 부정 사용하거나 본인확인·소명 요구에 정당한 사유 없이 불응한 경우 </p>
      <p>7. 서비스 이용으로 취득한 시스템 관련 정보를 회사의 사전 승낙 없이 복제·유통·상업적 이용한 경우(스크래핑, 리버스엔지니어링, 우회접속 포함) </p>
      <p>8. 타인의 명예를 훼손하거나 모욕, 괴롭힘, 차별·혐오 표현 등 사회 통념상 현저히 부적절한 행위를 한 경우 </p>
      <p>9. 서비스 또는 외부 채널 연동에 위해를 가하거나 건전한 이용을 저해하는 경우, 또는 채널 정책 위반으로 연동에 중대한 장애를 초래한 경우 </p>
      <p>10. 토큰의 부정 사용(양도·대여·판매·대리 생성 등), 요금 회피(결제 우회, 차지백 남용 등), 자동화 남용(봇·스크립트로 대량 생성/업로드) 등 서비스 질서를 저해한 경우 </p>
      <p>11. 회사의 채권보전을 위해 요청한 증빙서류를 허위 작성·제출한 경우 </p>
      <p>12. 불법선거운동 또는 그에 준하는 위법 목적의 이용이 확인된 경우 </p>
      <p>13. 국익 또는 사회적 이익에 현저히 반하는 목적으로 서비스를 이용한 경우 </p>
      <p>14. 그 밖에 회사가 합리적으로 판단하여 서비스의 안전한 운영에 중대한 위험이 있는 경우 </p>

      <p>⑧ 회사는 회원에게 도움과 혜택이 될 수 있다고 판단되는 경우, 일시적 또는 주기적으로 공지·안내·이벤트 등 광고성 정보를 제공할 수 있습니다. 회원이 수신 거부 의사를 고객센터 등으로 표시한 경우에는 발송하지 않습니다.</p>

      <h3 className="font-semibold py-2">제15조(서비스의 변경)</h3>
      <p>① 회사는 상당한 이유가 있는 경우 운영상·기술상의 필요에 따라 제공 중인 전부 또는 일부 서비스를 변경할 수 있습니다. </p>
      <p>② 회사는 서비스의 내용, 이용방법, 이용시간에 변경이 있는 경우 변경사유, 변경될 서비스의 내용 및 제공일자 등을 변경 전에 서비스 내 공지사항 등에 게시합니다. </p>
      <p>③ 회사는 무료로 제공되는 서비스에 대하여 일부 또는 전부를 회사의 정책 및 운영상 필요로 수정·중단·변경할 수 있으며, 이에 대하여 관련 법령 등에 특별한 규정이 없는 한 회원에게 별도의 보상을 하지 않습니다.</p>

      <h3 className="font-semibold py-2">제16조(서비스 이용의 제한 및 정지)</h3>
      <p>① 회사는 회원이 본 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우 서비스 이용을 제한하거나 정지할 수 있습니다. </p>
      <p>② 회사는 회원의 개인정보 보호를 위하여 12개월 이상 서비스 접속을 포함한 이용이 없는 계정을 휴면계정으로 분류하여 서비스 이용을 정지하고 별도 관리할 수 있습니다. 이 경우 회원은 휴면기간 내 휴면 해제 또는 재접속을 통해 휴면 상태를 해제할 수 있습니다. </p>
      <p>③ 회사의 귀책사유가 없는 서비스 이용 제한·정지 또는 장애로 인하여 발생한 손해에 대하여 회사는 책임을 지지 않습니다. </p>
      <p>
        ④ 회사는 주민등록법을 위반한 명의도용 및 결제도용, 저작권법을 위반한 불법 프로그램 제공 및 운영방해, 정보통신망법을 위반한 불법 통신, 해킹, 악성프로그램 배포, 접속권한 초과행위 등 관련 법령을 위반한 경우 즉시 영구 정지할 수 있습니다. 본 항에 따라 이용정지 시 서비스 내 금액·포인트·혜택 및 권리 등은 소멸하며 회사는 별도 보상하지 않습니다. 
      </p>
      <p>⑤ 사업 종목 전환, 사업 포기, 업체 간 통합 등으로 서비스를 제공할 수 없게 되는 경우 회사는 서비스 내 공지 또는 등록 연락처를 통해 통지한 후 서비스를 종료할 수 있습니다.</p>

      <h3 className="font-semibold py-2">제16조의2(이용제한의 절차 및 이의신청)</h3>
      <p>회사는 이용제한 조치 시 사유·범위·시점·이의신청 방법을 회원에게 통지합니다(긴급 차단의 경우 사후 통지).</p>
      <p>회원은 통지를 받은 날부터 14일 이내 서면·이메일 등으로 이의신청을 할 수 있으며, 회사는 접수일로부터 14일 이내 처리 결과를 통지합니다. 부득이한 경우 10일 범위 내 1회 연장할 수 있으며, 연장 사유를 통지합니다.</p>

      <h3 className="font-semibold py-2">제17조(서비스 이용의 연장 및 변경)</h3>
      <p>① 회원은 서비스 가입을 완료하고 정기 월 단위 또는 회사가 정한 기간의 이용료를 결제하면 서비스를 이용할 수 있는 권리를 획득합니다. </p>
      <p>② 회원은 이용기간 만료 후 별도의 해지 의사 표시가 없는 경우, 기존과 동일한 조건으로 자동 갱신(자동 결제) 됩니다. 회사는 갱신 예정일 7일 전까지 갱신 사실 및 금액을 고지합니다. </p>
      <p>③ 회원은 서비스의 명의 이전, 양도, 상속 또는 회원 정보 변경 사유가 발생한 경우 회사에 통지하고 회사의 동의를 얻어야 합니다. </p>
      <p>④ 회원이 변경사항을 통지하지 아니함으로 인하여 발생하는 불이익은 회원이 부담합니다.</p>

      <h3 className="font-semibold py-2">제18조(서비스 이용의 탈퇴·해지 및 환급)</h3>
      <p>① 회원은 서비스 이용을 해지하고자 할 때 본인이 직접 서비스를 통하여 신청할 수 있으며, 요금의 미납 및 연체 시 회사는 정해진 절차에 따라 탈퇴 및 해지를 처리할 수 있습니다. </p>
      <p>② 회원은 다음 각 호의 사유가 있는 경우 서비스 탈퇴 또는 해지할 수 있으며, 회원이 회사에 의사를 표시한 때에 그 효력이 발생합니다. </p>
      <p>1. 회원이 더 이상 서비스 이용을 원하지 않는 경우 </p>
      <p>2. 서비스의 하자를 회사가 보완·수정할 수 없는 경우</p>
      <p>3. 회원이 개정 약관에 동의하지 않는 경우 </p>
      <p>③ 회사는 다음 각 호에 해당할 경우 회원의 동의 없이 이용계약을 해지할 수 있으며, 그 사실을 지체 없이 통지합니다. 다만 긴급히 해지할 필요가 있거나 회원의 귀책사유로 통지할 수 없는 경우에는 예외로 합니다. </p>
      <p>1. 회원이 본 약관을 위반하고 상당 기간 내에 위반 내용을 해소하지 않은 경우 </p>
      <p>2. 회사의 서비스 제공 목적 외의 용도로 서비스를 이용하거나 제3자에게 임의로 서비스를 재임대한 경우 </p>
      <p>3. 관계기관의 적법한 요청에 따른 경우 </p>
      <p>4. 기타 관계 법령 위반으로 제재를 받은 경우 </p>
      <p>5. 제10조를 위반한 경우 </p>
      <p>6. 제16조에 따라 이용정지를 당한 이후 1년 이내에 이용정지 사유가 재발한 경우 </p>
      <p>7. 회사의 이용요금 납부 청구에 대하여 회원이 요금을 미납한 경우 </p>
      <p>
        ④ 회원이 계약을 해지할 경우 관련 법 및 개인정보처리방침에 따라 회사가 회원 정보를 보유하는 경우를 제외하고는 해지 후 1개월간 데이터 보존을 원칙으로 합니다. 이후 완전 삭제되며 복구되지 않습니다.
      </p>
      <p>⑤ 서비스 이용요금을 납부한 회원에 한하여 다음의 환급정책(월납 기준)을 적용합니다. </p>
      <p>1. 이용일로부터 7일 이내 환불 신청: 이용금액(토큰 사용량)의 25% 공제 후 환불 </p>
      <p>2. 이용일로부터 15일 이내 환불 신청: 이용금액의 50% 공제 후 환불 </p>
      <p>3. 이후 신청: 환불 불가 </p>
      <p>4. 결제취소·환불 처리 시 발생하는 각종 수수료는 환불액에서 제외할 수 있습니다. </p>
      <p>5. 무상으로 지급된 프로모션 혜택(예: 이벤트 쿠폰·무상 토큰 등)은 환불되지 않습니다. 이미 사용한 유상 토큰은 환불 계산에서 제외됩니다. </p>
      <p>6. 현행 법령 및 중대한 약관 위반 등 회원의 귀책사유로 서비스 이용이 해지된 경우 환불되지 않습니다.</p>
      <p>
        ⑥ 디지털 콘텐츠 특성상 토큰 사용이 개시되거나 AI 생성물이 생성된 이후에는 관련 법령이 허용하는 범위 내에서 청약철회가 제한될 수 있습니다. 회사는 결제 전 화면 및 운영정책을 통해 철회 제한 사유·절차를 고지합니다.
      </p>

      <h2 className="font-semibold">제6장 이용요금</h2>

      <h3 className="font-semibold py-2">제19조(요금의 청구 및 납입)</h3>
      <p>
        ① 요금 산정을 위한 과금 주기는 월 단위 정산을 기준으로 하며, 서비스 이용 요금은 회사가 제공하는 결제 시스템을 이용하여 선결제를 원칙으로 합니다. 다만, 사안에 따라 회사와 협의하여 계좌이체, 무통장 입금 등 기타 방법으로 선결제 또는 후결제를 할 수 있습니다. 
      </p>
      <p>② 월 단위 이외에 필요에 따라 6개월/1년 단위 결제가 가능하며, 이 경우 서비스 이용 회선(또는 이용 권리)의 수량·단위·기간 등에 따라 회사가 정한 별도의 할인율 및 결제 방식에 따릅니다.</p>

      <h3 className="font-semibold py-2">제20조(요금의 계산 및 청구·납입)</h3>
      <p>① 서비스별 요금의 기준 등은 별첨 1에 따릅니다. </p>
      <p>
        ② 본 서비스는 이용계약 체결과 동시에 이루어지는 선결제를 통해 이용이 개시되며, 회원이 해지 의사를 표시하지 않을 경우 자동으로 청구·납입되어 이용계약 및 이용 권한이 연장됩니다. 
      </p>
      <p>
        ③ 회사는 서비스 이용이 정지된 기간 중에는 월정액 요금을 청구하지 않으며, 회원의 책임 없는 사유로 해당 서비스를 이용할 수 없었던 기간 등 이용 제한 기간 동안의 요금은 청구하지 않습니다. 
      </p>
      <p>④ 회사는 개별 단위로 분산 청구되는 요금을 회원과 협의하여 통합 청구할 수 있습니다. 회원의 신청이 있는 경우 회사는 해당 서비스 요금을 분리하여 재청구할 수 있습니다.</p>

      <h3 className="font-semibold py-2">제21조(요금에 대한 이의신청 및 청구권 소멸시효)</h3>
      <p>
        ① 회원은 청구·납입된 요금에 이의가 있는 경우 납입일로부터 3개월 이내에 이의 신청을 할 수 있습니다. 다만, 회사의 귀책사유로 과·오납이 발생한 경우에는 언제든지 이의 신청을 할 수 있습니다. 
      </p>
      <p>
        ② 회사는 전항의 이의 신청을 받은 날로부터 14일 이내에 처리 결과를 통지합니다. 부득이한 사유로 14일 이내 통지가 어려운 경우 그 만료일 다음 날부터 10일 범위에서 한 차례 연장할 수 있으며, 연장 사유를 회원에게 통지합니다. 
      </p>
      <p>
        ③ 회사의 귀책사유로 서비스가 중단된 경우 장애 시간이 3시간 이상이면 장애가 발생한 1일 평균 이용요금의 2배에 해당하는 토큰을 보상합니다. 단, 보상 금액은 해당 서비스별 최고 1개월 이용요금을 초과할 수 없으며, 당사자 협의 하에 서비스 기간 연장으로 갈음할 수 있습니다. 
      </p>
      <p>④ 회사의 회원에 대한 요금 청구권의 소멸시효는 민법 또는 상법에 따릅니다.</p>

      <h3 className="font-semibold py-2">제22조(사용료의 지불방법 및 납부자)</h3>
      <p>① 회원은 본 약관에서 정한 사용료에 대하여 회사가 제공하는 결제 시스템을 이용하여 납기일까지 지급하여야 합니다. </p>
      <p>
        ② 해당 서비스의 사용료는 회사와 이용계약을 체결한 계약자(또는 회원)가 그 명의로 납부하는 것을 원칙으로 하며, 계약자와 실제 이용자가 다를 경우 즉시 회사에 통보하여 동의를 얻어야 합니다. 이 경우 납부 명의자의 이의 제기에 대하여 회사는 책임을 지지 않으며, 이용자가 이를 입증·해결하여야 합니다. 
      </p>
      <p>
        ③ 이용자가 타인의 명의를 도용하여 이용계약을 체결한 사실이 밝혀진 경우, 도용당한 자는 해당 요금 납입 책임이 면제되며, 실제 이용자가 요금 및 관련 법적 책임을 부담합니다.
      </p>

      <h3 className="font-semibold py-2">제23조(요금의 납기일 및 미납 요금의 징수)</h3>
      <p>① 요금 납기일은 회원의 서비스 이용 시작일을 기준으로 정합니다(서비스 이용 신청 및 납입 완료 기준). </p>
      <p>
        ② 회사는 회원이 요금을 연장하지 않을 경우 최종 납부(독촉) 기한 및 미납 시 서비스 이용이 중지된다는 내용을 통지하여야 합니다. 통지 후 서비스 이용기간 내에도 납부하지 않을 경우 회사는 별도 통지 없이 유료계약을 해지할 수 있습니다. 
      </p>
      <p>③ 회사는 회원이 요금을 과·오납한 경우 그 요금을 반환하거나 차기 요금에서 정산할 수 있습니다.</p>

      <h2 className="font-semibold">제7장 손해배상·면책 등</h2>

      <h3 className="font-semibold py-2">제24조(손해배상 및 면책)</h3>
      <p>① 회사와 회원은 고의 또는 과실로 상대방에게 손해를 발생시킨 경우 귀책 당사자가 손해를 배상합니다. 다만, 천재지변, 정부의 규제 등 불가항력적 사유가 있는 경우에는 그러하지 아니합니다. </p>
      <p>
        ② 회원이 관련 법령, 본 약관, 운영정책에서 정한 의무를 이행하지 않아 제3자로부터 소송·청구·이의 제기를 당한 경우, 회원은 회사에 책임이 귀속되지 않도록 방어하고 관련하여 발생한 총 비용(손해배상 포함)을 부담합니다. 
      </p>
      <p>
        ③ 회원이 본 약관 또는 법령상 의무를 위반하여 서비스의 품질 하락 또는 신뢰도 저하 등을 초래한 경우, 회원은 그로 인해 회사가 입은 손해를 배상하여야 합니다. 
      </p>
      <p>
        ④ 회사의 귀책사유로 인한 손해배상 청구는 청구 사유·청구 금액 및 산출 근거를 기재하여 서면으로 하여야 하며, 손해배상액은 1개월(30일) 이용요금을 초과할 수 없습니다(법령상 달리 정함이 없는 한). 
      </p>
      <p>⑤ 회사는 다음 각 호의 어느 하나로 서비스를 제공할 수 없는 경우 서비스 제공에 대한 책임이 면제됩니다. </p>
      <p>1. 천재지변 또는 이에 준하는 불가항력 </p>
      <p>2. 서비스의 효율적 제공을 위한 시스템 개선, 장비 증설 등 계획된 서비스 중지(사전 공지된 경우) </p>
      <p>3. 회원의 전산망 장애로 발생하는 서비스 지연 또는 불능 </p>
      <p>4. 회사의 서비스 시스템의 정기 점검 또는 업데이트로 인한 제한 </p>
      <p>5. 회선·통신망을 제공하는 통신사업자 등 제3자의 장애·귀책사유 </p>
      <p>6. 서비스 제공을 위하여 회사와 제휴한 제3자의 고의적인 서비스 방해 </p>
      <p>7. 회원의 귀책사유로 인한 장애 </p>
      <p>8. 회사의 고의·중과실이 없는 사유 </p>
      <p>9. 채널 업로드 실패·지연 등 외부 채널 요인에 기인한 손해(회사 고의·중과실 제외) </p>
      <p>⑥ 회사는 회원이 서비스를 통해 얻은 정보 또는 자료 등으로 인하여 발생한 손해와, 서비스를 이용하거나 이용할 것으로부터 기대되는 이익(기대이익)에 대하여 책임지지 않습니다. </p>
      <p>
        ⑦ 회사는 회원이 게시 또는 전송한 자료의 출처·내용의 적법성 및 정확성·신뢰성·시의성 등을 보증하지 않으며, 해당 내용이 법령을 위반하거나 제3자의 권리를 침해하는 경우 이에 대한 책임을 지지 않습니다. 
      </p>
      <p>⑧ 회사는 회원 상호 간 또는 회원과 제3자 상호 간에 본 서비스를 매개로 발생한 분쟁에 개입할 의무가 없으며, 이로 인한 손해를 배상할 책임이 없습니다. </p>
      <p>⑨ 회사는 무료 제공 서비스에 대하여 회사의 귀책사유로 회원에게 서비스를 제공하지 못하는 경우 그 손해를 배상할 책임이 없습니다. </p>
      <p>⑩ 회사는 부득이한 사유로 인한 일시적 장애로 발생한 간접손해·영업손실 등에 대해 책임을 지지 않습니다(법이 허용하는 범위 내).</p>

      <h3 className="font-semibold py-2">제25조(분쟁 조정 및 관례)</h3>
      <p>
        ① 본 약관은 대한민국 법령에 의하여 규율·해석됩니다. 본 약관에서 정하지 않은 사항과 해석에 관하여는 “전기통신사업법”, “정보통신망법”, “전자상거래 등에서의 소비자보호에 관한 법률”, “약관의 규제에 관한 법률”, “전자서명법”, “소비자기본법” 및 기타 관계 법령 또는 상관례에 따릅니다. 
      </p>
      <p>② 서비스 이용과 관련하여 회사와 회원 간에 발생한 분쟁은 민사소송법상 회사의 주소지를 관할하는 법원을 제1심 전속 관할로 합니다.</p>

      <h3 className="font-semibold py-2">제26조(AI 생성물에 관한 고지)</h3>
      <p>① AI 생성물은 알고리즘 특성상 결과가 가변적이며 정확성·완전성이 보장되지 않을 수 있습니다. </p>
      <p>
        ② 회원은 AI 생성물 및 업로드할 콘텐츠가 관련 법령, 제3자의 권리(초상권·상표권·저작권 등), 채널 정책을 침해하지 않도록 사전 검토·확인할 책임이 있습니다. 
      </p>
      <p>③ 회원이 채널에 게시·공유한 콘텐츠에 관한 법적 책임은 회원에게 귀속됩니다.</p>
    </article>
  );
}
